import React from "react";
import { Switch, Route } from "react-router-dom";
import Error404 from "../../../Error404";

import KnowledgeChunkList from "./KnowledgeChunkList";

export default ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}`} exact component={KnowledgeChunkList} />
      <Route component={Error404} />
    </Switch>
  );
};
